import LoadingButton from "@mui/lab/LoadingButton";
import Dialog from "@mui/material/Dialog";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { FC } from "react";

interface Props {
  open: boolean;
  onProceed: () => void;
  isLoading: boolean;
}

/**
 * Modal shown when user tries to login but has not completed email verification
 */
const IncompleteSignupDialog: FC<Props> = ({ open, onProceed, isLoading }) => {
  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          bgcolor: "white",
          color: "white",
        },
      }}
    >
      <Grid container direction="column" alignItems="center">
        <Grid item pt={4}>
          <Typography color="#242627" fontSize={25} fontWeight={700}>
            Complete Your Registration
          </Typography>
        </Grid>
        <Grid item px={5} py={2}>
          <Typography
            color="#242627"
            fontSize={16}
            fontWeight={300}
            textAlign="center"
          >
            Your signup process was not completed. To continue, we need to
            verify your email address.
            <br />
            <br />
            Click the button below to receive a new verification code.
          </Typography>
        </Grid>
        <Grid item mt={5} mb={2}>
          <LoadingButton
            loading={isLoading}
            size="large"
            variant="contained"
            sx={{
              color: "#FFF",
              textTransform: "none",
              border: "1px solid rgba(0, 0, 148, 0.4)",
            }}
            onClick={onProceed}
          >
            Continue
          </LoadingButton>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default IncompleteSignupDialog;
